module.exports = __webpack_public_path__ + "static/media/airplane.9e998e69.svg";